import React, { useState, useEffect } from "react";
import { Modal, Button, Radio, Space, Typography } from "antd";
import { useNavigate } from "react-router-dom";

const { Title, Text } = Typography;

const useIsMobile = (breakpoint = 576) => {
  const [isMobile, setIsMobile] = useState(
    typeof window !== "undefined" ? window.innerWidth < breakpoint : false
  );

  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth < breakpoint);
    };

    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, [breakpoint]);

  return isMobile;
};

interface TeamModalProps {
  visible: boolean;
  onClose: (dismissed?: boolean) => void;
  taskId: string;
  userId: string;
  onNavigateWithMode?: (mode: "create" | "select") => void;
}

const TeamModal: React.FC<TeamModalProps> = ({
  visible,
  onClose,
  taskId,
  onNavigateWithMode,
}) => {
  const navigate = useNavigate();
  const isMobile = useIsMobile();
  const [selectedMode, setSelectedMode] = useState<"create" | "select">("create");

  const handleOk = () => {
    // Navigate to team page
    // navigate(`/team/${taskId}`, {
    //   state: {
    //     mode: selectedMode,
    //     shouldOpenModal: selectedMode === "create",
    //   },
    // });

    // Call callback if provided
    if (onNavigateWithMode) {
      onNavigateWithMode(selectedMode);
    }

    onClose(true);
  };

  const handleCancel = () => {
    setSelectedMode("create");
    onClose(true); // dismissed = true บอกว่า user ปิด modal เอง
  };

  return (
    <Modal
      title={null}
      open={visible}
      onCancel={handleCancel}
      footer={null}
      width={isMobile ? "90%" : 500}
      centered
    >
      <div style={{ padding: isMobile ? "10px 0" : "20px 0" }}>
        <Title
          level={isMobile ? 5 : 4}
          style={{ textAlign: "center", marginBottom: isMobile ? 20 : 30 }}
        >
          คุณมีทีมหรือยัง?
        </Title>

        <Radio.Group
          value={selectedMode}
          onChange={(e) => setSelectedMode(e.target.value)}
          style={{ width: "100%" }}
        >
          <Space direction="vertical" style={{ width: "100%" }} size={isMobile ? "middle" : "large"}>
            <Radio value="select" style={{ fontSize: isMobile ? 14 : 16 }}>
              <Text style={{ fontSize: isMobile ? 14 : 16 }}>ดูรายชื่อทีมที่ต้องการเข้า</Text>
            </Radio>
            <Radio value="create" style={{ fontSize: isMobile ? 14 : 16 }}>
              <Text style={{ fontSize: isMobile ? 14 : 16 }}>สร้างทีมใหม่</Text>
            </Radio>
          </Space>
        </Radio.Group>

        <div
          style={{
            display: "flex",
            flexDirection: isMobile ? "column" : "row",
            justifyContent: "center",
            gap: isMobile ? 8 : 10,
            marginTop: isMobile ? 24 : 40,
          }}
        >
          <Button
            onClick={handleCancel}
            size={isMobile ? "middle" : "large"}
            block={isMobile}
          >
            ยกเลิก
          </Button>
          <Button
            type="primary"
            onClick={handleOk}
            size={isMobile ? "middle" : "large"}
            block={isMobile}
          >
            ตกลง
          </Button>
        </div>
      </div>
    </Modal>
  );
};

export default TeamModal;
